import { FlowDurationUnits } from 'flow-schema';

import { describeJitter } from './describeJitter';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../../ConfigFields/Duration';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

export function WaitV2FormFields() {
  const { value: jitter } = useSelectedNodeField<unknown>('config.jitter');

  return (
    <>
      <BlockDurationField
        fieldName="config.duration"
        unitFieldNameSuffix="units"
        required={false}
        allowedUnits={Object.values(FlowDurationUnits)}
        toggleLabel="Use pre-defined wait duration"
        valueLabel="Pre-defined wait duration"
        valueHelperText="The amount of time to wait."
      />
      <BlockValueTemplateField
        fieldName="config.waitUntilDate"
        label="Dynamic wait duration or target datetime"
        helperText="The number of milliseconds to wait, or target datetime until which to wait. This can be dynamically specified via {{...}} notation."
        required={false}
      />
      <BlockDurationField
        fieldName="config.jitter"
        unitFieldNameSuffix="units"
        required={false}
        allowedUnits={Object.values(FlowDurationUnits)}
        defaultUnit={FlowDurationUnits.Seconds}
        toggleLabel="Add a random extra wait"
        valueLabel="Extra wait, up to"
        valueHelperText={describeJitter(jitter)}
      />
    </>
  );
}
